import { Container } from "@/components/common/Container";
import { Marquee } from "@/components/common/Marquee";
import { Reveal } from "@/components/common/Reveal";
import { technologyHighlights } from "@/data/home.data";
// import { clientLogos } from "@/data/home.data";
import { Star } from "@/icons";

/** Trust band — social proof headline, rating and a slow wordmark marquee. */
export function TrustBar() {
  return (
    <section className="border-y border-border bg-card/60 py-14">
      <Container>
        <Reveal>
          <div className="mb-10 flex flex-col items-center gap-4 text-center">
            <div className="flex items-center gap-1.5" aria-label="Rated 4.9 out of 5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-warning text-warning" />
              ))}
              <span className="ml-2 text-sm font-medium text-foreground">
                Modern Technology Stack Built for Scale
              </span>
              <span className="text-sm text-muted-foreground">
                AI Ready . Cloud Native
              </span>
            </div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
              Built using modern, enterprise-grade technologies.
            </p>
          </div>
        </Reveal>
      </Container>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-background to-transparent" />
        <Marquee
          // items={clientLogos}
          items={technologyHighlights}
          speed={34}
          className="[&_span]:font-heading [&_span]:font-semibold [&_span]:text-foreground/70"
        />
      </div>
    </section>
  );
}
